module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Changelog")]), _vm._v(" "), _vm._l((_vm.changelog), function(changes, key) {
    return _c('div', {
      staticClass: "flexRow changelog"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("\n      " + _vm._s(key) + "\n    ")]), _vm._v(" "), _c('ul', _vm._l((changes), function(change) {
      return _c('li', [_vm._v("\n        " + _vm._s(change) + "\n      ")])
    }), 0)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-736542df!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/ChangelogView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-736542df!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/ChangelogView.vue
// module chunks = 0